import './App.css';
import Hero from "./blocks/Hero/Hero";
import FirstSection from "./blocks/FirstSection/FirstSection";
import Services from "./blocks/Services/Services";
import Footer from "./blocks/Footer/Footer";


function App() {
  return (
      <div className="App">
        <Hero />
        <FirstSection />
        <Services />
        <Footer />

      </div>
  );
}

export default App;
